export default "__VITE_ASSET__DNX6qNRn__"